import React from 'react';
import { Icon } from '@iconify/react'; // Import Icon from @iconify/react
import { formatDateAccordingTo } from '..';

const getStatusColor = (status) => {
  switch (status) {
    case "Waiting": return "#ff9900";
    case "Dispatched": return "#2850ab";
    case "Enroute": return "#90ee90";
    case "On Scene": return "#008000";
    case "Towing": return "#3294F5";
    case "Destination Arrival": return "#d700c9";
    case "Completed": return "#ccc";
    default: return "gray";
  }
};

const TimeLineRouteForJob = ({ status, statusList }) => {
  // Find the current status index
  const currentStatusIndex = statusList.findIndex((item) => item.label === status);
  
  return (
    <div style={styles.timelineContainer}>
      {statusList.map((item, index) => (
        <div key={item.id} style={styles.timelineItem}>
          {/* Circle and Icon */}
          <div
            style={{
              ...styles.circle,
              backgroundColor: index <= currentStatusIndex ? getStatusColor(item.label) : '#e0e0e0',
            }}
          >
            <Icon
              icon={item.icon} // Use the `icon` prop to specify the icon
              width={20} // Set width and height
              height={20}
              color={index <= currentStatusIndex ? '#fff' : '#888'}
            />
          </div>

          {/* Label and Time */}
          <div style={styles.labelContainer}>
            <p
              style={{
                ...styles.label,
                color: index <= currentStatusIndex ? '#000' : '#888',
              }}
            >
              {item.label}
            </p>
            <p
              style={{
                ...styles.time,
                color: index <= currentStatusIndex ? '#000' : '#888',
              }}
            >
              {formatDateAccordingTo(item.time)}
            </p>
          </div>

          {/* Vertical Line */}
          {index < statusList.length - 1 && (
            <div
              style={{
                ...styles.verticalLine,
                backgroundColor: index < currentStatusIndex ? getStatusColor(item.label) : '#e0e0e0',
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

// Styles (using inline styles for simplicity, but you can use CSS modules or styled-components)
const styles = {
  timelineContainer: {
    margin: '16px 0',
  },
  timelineItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
    position: 'relative',
  },
  circle: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '16px',
  },
  labelContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
  },
  label: {
    fontSize: '16px',
    margin: 0,
  },
  time: {
    fontSize: '14px',
    marginLeft: '8px',
  },
  verticalLine: {
    position: 'absolute',
    left: '19px', // Center of the circle
    top: '40px', // Below the circle
    width: '2px',
    height: '40px', // Height between circles
  },
};

export default TimeLineRouteForJob;